import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { MULTI_PACKAGE } from './constants';

const messages = defineMessages({
  multiPackage: {
    description: 'Label for the multi-package filter',
    defaultMessage: 'Multi-Package',
    id: 'GIJBao',
  },
});

export const multiPackageFilterArgument = {
  id: 'option-packageType',
  displayName: <FormattedMessage {...messages.multiPackage} />,
  value: MULTI_PACKAGE,
};
